<template>
  <div class="payment wrapper_1200">
    <div class="header">
      <span class="home"><nuxt-link class="home" to="/">{{ $tt('首页') }}  </nuxt-link> > {{ $tt('个人中心') }} ></span>{{ $tt('确认订单') }}
    </div>
    <div class="orderTip">
      <div>{{ $tt('订单提交成功！去付款咯~') }}</div>
      <div class="times acea-row row-middle">
        <div>{{ $tt('剩余时间：') }}</div>
        <countDown v-if="orderDetail.cancel_unix" :is-day="false" :tip-text="' '" :day-text="' '" :hour-text="$tt(' 小时 ')"
                   :minute-text="$tt(' 分钟 ')" :second-text="$tt('秒 ')"
                   :datatime="orderDetail.cancel_unix"></countDown>
      </div>
    </div>
    <div class="detail">
      <div class="item">{{ $tt('订单编号：') }}{{ orderDetail.order_id ? orderDetail.order_sn : orderDetail.group_order_sn }}</div>
      <div class="item">{{ $tt('订单价格：') }}<span class="order_price">${{ orderDetail.pay_price }}</span></div>
      <div class="item line1">{{ $tt('收货信息：') }}{{ orderDetail.real_name }} {{ orderDetail.user_phone }}
        {{ orderDetail.user_address }}
      </div>
      <div v-if="type == 2" class="item line1">
         {{ $tt('商品名称：') }}{{ orderDetail.orderProduct&&orderDetail.orderProduct.length ? orderDetail.orderProduct[0].cart_info.product.store_name : '' }}
      </div>
      <div v-else class="item line1">
        {{ $tt('商品名称：') }}{{ orderDetail.orderList&&orderDetail.orderList.length ? orderDetail.orderList[0].orderProduct[0].cart_info.product.store_name : '' }}
      </div>
    </div>
    <div class="payType">
      <div class="title">{{ $tt('选择以下支付方式') }}</div>
      <div class="type acea-row row-middle">
        <div
          v-for="item in payMethods"
          :key="item.value"
          class="item"
          :class="current === item.value ? 'on' : ''"
          @click="currentPay(item.value)"
        >
          <div class="pay-main">
            <img v-if="item.image" class="pay-image" :src="item.image" :alt="$tt(item.name)" />
            <div v-else-if="item.icon" class="iconfont" :class="item.icon"></div>
            <div v-else class="custom-pay-icon" :class="item.badgeClass">{{ item.badgeText }}</div>
            <div class="name">{{ $tt(item.name) }}</div>
          </div>
          <div class="iconfont icon-xuanzhong4 font-color" v-if="current === item.value"></div>
        </div>
      </div>
      <div class="goPay acea-row row-right">
        <button class="button" @click="goPay" :disabled="disabeld">{{ $tt('去支付') }}</button>
      </div>
    </div>
    <!--微信支付宝支付弹窗-->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :center="true"
    >
      <div class="wxPay">
        <div class="wrapper">
          <div class="title acea-row row-between-wrapper">
            <div>{{ $tt(activePayMethod.name || '扫码支付') }}</div>
            <div class="amount">{{ $tt('应付金额：') }}<span class="num font-color">${{ orderDetail.pay_price }}</span></div>
          </div>
          <div class="acea-row row-center-wrapper">
            <div class="wx">
              <div class="pictrue">
                <client-only>
                  <vue-qr
                    v-if="codeUrl"
                    :key="qrCodeKey"
                    class="bicode"
                    :text="codeUrl"
                    :size="310"
                  ></vue-qr>
                </client-only>
                <div v-if="failCode" class="fail-code" @click="goPay">
                  <div class="fail-code-info">
                    <img src="../assets/images/fail-code.png" />
                    <div>{{ $tt('二维码失效，点击重新获取') }}</div>
                  </div>
                </div>
              </div>
              <div class="text acea-row row-center-wrapper">
                <div class="iconfont icon-saoyisao"></div>
                <div>
                  <div>{{ $tt(activePayMethod.scanText || '请扫码支付') }}</div>
                  <div class="tip">{{ $tt('扫描二维码支付') }}</div>
                </div>
              </div>
            </div>
            <div v-if="activePayMethod.dialogImage" class="phone">
              <img :src="activePayMethod.dialogImage" />
            </div>
          </div>
          <div class="selectPay" @click="handleClose"><span class="iconfont icon-fanhui"></span>{{ $tt('选择其他支付方式') }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import countDown from '@/components/countDown';
export default {
  name: "payment",
  auth: "guest",
  components: {
    countDown
  },
  data() {
    return {
      orderId: 0,
      type: '',
      orderDetail: {},
      current: '',
      userInfo: {},
      payType: '',
      disabeld: false,
      dialogVisible: false,
      totalPrice: 0,
      codeUrl: '',
      qrCodeKey: 0,
      payRequestToken: 0,
      invalid: 0,
      endTime: '',
      timeName: null,
      failCode: false,
      failCodeStatus: null,
      yue_status: 0,
      qrDialogImages: {
        wechatByIEPay: require('@/assets/images/phone.png')
      }
    }
  },
  async asyncData({app, query}) {
    let [userInfoMsg] = await Promise.all([

      app.$axios.get('/api/user')
    ]);
    return {
      orderId: query.result,
      type: query.type,
      userInfo: userInfoMsg.data,
      disabeld: false
    }
  },
  watch: {
    endTime(n) {
      if (n === 1) {
        this.clearStatus();
      }
    },
  },
  computed: {
    payMethods() {
      const methods = [];
      if (this.yue_status === 1) {
        methods.push({
          value: 'balance',
          name: '余额支付',
          icon: 'icon-yue'
        });
      }
      methods.push(
        {
          value: 'alipayByIEPay',
          name: '支付宝支付',
          image: '/images/pay_icons/ali-pay.png'
        },
        {
          value: 'wechatByIEPay',
          name: '微信支付',
          image: '/images/pay_icons/wechat-pay.png',
          scanText: '请使用微信扫一扫',
          dialogImage: this.qrDialogImages.wechatByIEPay
        },
        {
          value: 'unionPay',
          name: '银联支付',
          image: '/images/pay_icons/union-pay.png',
          scanText: '请使用银联扫一扫'
        },
        {
          value: 'poliPay',
          name: 'POLI',
          image: '/images/pay_icons/poli-pay.png',
          scanText: '请使用POLI扫码付款'
        }
      );
      return methods;
    },
    activePayMethod() {
      return this.payMethods.find(item => item.value === this.current) || {};
    },
    successPath() {
      return this.type == 2 ? '/user/presell_order' : '/user/order_list?type=1';
    }
  },
  fetch({store}) {
    store.commit('isHeader', true);
    store.commit('isFooter', true);
  },
  head() {
    return {
      title: "支付-" + this.$store.state.titleCon
    }
  },
  beforeMount() {},
  mounted() {
    if (!this.orderId) {
      this.orderId = this.$route.query.result || 0;
    }
    if (!this.type) {
      this.type = this.$route.query.type || '';
    }
    this.getOrderInfo();
    this.getPayType();
  },
  beforeDestroy() {
    this.clearStatus();
    this.clearFailCodeStatus();
  },
  methods: {
    //获取支付方式状态
    getPayType(){
      let that = this;
      that.$axios.get("/api/config").then(res => {
        that.yue_status = res.data.yue_pay_status;
        that.initPayType();
      }).catch(err => {
        that.$message.error(err);
      });
    },
    initPayType() {
      if (!this.payMethods.length) {
        this.current = '';
        this.payType = '';
        return;
      }
      if (!this.payMethods.some(item => item.value === this.current)) {
        this.current = this.payMethods[0].value;
        this.payType = this.payMethods[0].value;
      }
    },
    clearStatus() {
      if (this.timeName) {
        clearInterval(this.timeName);
      }
      this.timeName = null;
    },
    clearFailCodeStatus() {
      if (this.failCodeStatus) {
        clearTimeout(this.failCodeStatus);
        this.failCodeStatus = null;
      }
    },
    createPayRequestToken() {
      this.payRequestToken += 1;
      return this.payRequestToken;
    },
    isActivePayRequest(token) {
      return token === this.payRequestToken;
    },
    resetQrcode() {
      this.codeUrl = '';
      this.failCode = false;
      this.qrCodeKey += 1;
    },
    currentPay(value) {
      if (this.current && this.current !== value) {
        this.createPayRequestToken();
        this.clearFailCodeStatus();
        this.clearStatus();
        this.dialogVisible = false;
        this.disabeld = false;
        this.resetQrcode();
      }
      this.current = value;
      this.payType = value;
    },
    getOrderInfo(){
      let that = this;
      if(that.type == 2){
        that.$axios.get('/api/order/detail/' + that.orderId).then(res => {
          that.orderDetail = res.data
        }).catch(err => {
          that.$message.error(err);
        });
      }else{
        that.$axios.get('/api/order/group_order_detail/' + that.orderId).then(res => {
          that.orderDetail = res.data
        }).catch(err => {
          that.$message.error(err);
        });
      }
      
    },
    getPayApiUrl() {
      return this.type == 2 ? '/api/presell/pay/' + this.orderId : '/api/order/pay/' + this.orderId;
    },
    getPayStatusUrl() {
      return this.type == 2 ? '/api/presell/status/' + this.orderId : '/api/order/status/' + this.orderId;
    },
    getReturnUrl() {
      return window.location.protocol + "//" + window.location.host + this.successPath;
    },
    getExpectedIepayCode(type) {
      const expectedMap = {
        alipayByIEPay: 'IE0012',
        wechatByIEPay: 'IE0022',
        unionPay: 'IE0032',
        poliPay: 'IE0041'
      };
      return expectedMap[type] || '';
    },
    openPayUrlInNewWindow(payUrl) {
      const payWindow = window.open(payUrl, '_blank');
      if (payWindow) {
        payWindow.focus();
        return;
      }
      window.location.href = payUrl;
    },
    openQrcode(payUrl, requestToken = null) {
      if (requestToken !== null && !this.isActivePayRequest(requestToken)) {
        return;
      }
      this.resetQrcode();
      this.dialogVisible = true;
      this.disabeld = false;
      this.$nextTick(() => {
        if (requestToken !== null && !this.isActivePayRequest(requestToken)) {
          return;
        }
        this.codeUrl = payUrl;
        this.qrCodeKey += 1;
      });
      this.failCodeStatus = setTimeout(() => {
        if (requestToken !== null && !this.isActivePayRequest(requestToken)) {
          return;
        }
        this.failCode = true;
      }, 1000 * 60 * 3);

      if (!this.timeName) {
        this.timeName = setInterval(() => {
          this.checkPayStatus(requestToken);
        }, 2000);
      }
    },
    goPay() {
      let that = this;
      this.disabeld = true
      this.clearFailCodeStatus();
      this.clearStatus();
      const requestToken = this.createPayRequestToken();
      if (!this.payType) {
        this.disabeld = false;
        return that.$message.error("请选择支付方式");
      }
      if (this.payType === 'balance' && parseFloat(that.userInfo.now_money) < parseFloat(that.orderDetail.pay_price)) {
        this.disabeld = false;
        return that.$message.error("余额不足");
      }
      if (this.payType === 'balance') {
        that.$axios.post(this.getPayApiUrl(), {
          type: that.payType,
          return_url: this.getReturnUrl()
        }).then(res => {
          if (!this.isActivePayRequest(requestToken)) {
            return;
          }
          if (res.data.status === 'error') {
            this.disabeld = false;
            that.$message.error(res.message);
            return
          }
          that.$message.success(res.message);
          that.gainCount()
          setTimeout(function () {
            that.$router.replace(that.successPath);
          }, 1000);
        }).catch(err => {
          if (!this.isActivePayRequest(requestToken)) {
            return;
          }
          this.disabeld = false;
          that.$message.error(err);
          setTimeout(function () {
            that.$router.push({path: '/'});
          }, 1000);
        })
      } else {
        that.$axios.post(this.getPayApiUrl(), {
          type: that.payType,
          return_url: this.getReturnUrl()
        }).then(res => {
          if (!this.isActivePayRequest(requestToken)) {
            return;
          }
          const responsePayType = res.data.result && res.data.result.data ? res.data.result.data.pay_type : '';
          const expectedPayType = this.getExpectedIepayCode(this.payType);
          if (expectedPayType && responsePayType && responsePayType !== expectedPayType) {
            this.disabeld = false;
            return that.$message.error('支付通道返回异常，当前选择 ' + expectedPayType + '，实际返回 ' + responsePayType);
          }
          if (res.data.status === 'error') {
            this.disabeld = false;
            that.$message.error(res.message);
            return
          }
          if (res.data.status === 'alipayByIEPay') {
            const payUrl = res.data.result.data && res.data.result.data.pay_url;
            if (!payUrl) {
              this.disabeld = false;
              return that.$message.error('未获取到支付链接');
            }
            this.disabeld = false;
            this.openPayUrlInNewWindow(payUrl);
            return;
          }
          if (['wechatByIEPay', 'unionPay', 'poliPay', 'weixinQr', 'alipayQr'].includes(res.data.status)) {
            const payUrl = res.data.result.data && res.data.result.data.pay_url ? res.data.result.data.pay_url : res.data.result.config;
            if (!payUrl) {
              this.disabeld = false;
              return that.$message.error('未获取到支付二维码');
            }
            this.openQrcode(payUrl, requestToken);
            return;
          }
          this.disabeld = false;
          that.$message.error('暂不支持当前支付方式');
        }).catch(err => {
          if (!this.isActivePayRequest(requestToken)) {
            return;
          }
          this.disabeld = false;
          that.$message.error(err);
          setTimeout(function () {
            that.$router.push({path: '/'});
          }, 1000);
        })
      }
    },
    gainCount: function() {
      let that = this;
      that.$axios.get('/api/user/cart/count').then(res=>{
        that.$store.commit('cartNum', res.data[0].count || 0);
      });
    },
    checkPayStatus(requestToken = null) {
      let that = this;
      that.$axios.get(this.getPayStatusUrl()).then(res => {
        if (requestToken !== null && !this.isActivePayRequest(requestToken)) {
          return;
        }
        that.endTime = res.data.paid;
        if (res.data.paid) {
          this.createPayRequestToken();
          this.clearStatus();
          this.clearFailCodeStatus();
          this.dialogVisible = false;
          this.resetQrcode();
          that.$message.success('支付成功');
          that.gainCount()
          setTimeout(function () {
            that.$router.replace(that.successPath);
          }, 1000);
        }
      }).catch(err => {
        if (requestToken !== null && !this.isActivePayRequest(requestToken)) {
          return;
        }
        that.$message.error(err);
        setTimeout(function () {
          that.$router.replace({path: '/'});
        }, 1000);
      })
    },
    handleClose() {
      this.createPayRequestToken();
      this.dialogVisible = false
      this.disabeld = false
      this.clearFailCodeStatus();
      this.clearStatus();
      this.resetQrcode();
    },
  }
}
</script>
<style scoped lang="scss">
.payment {
  .header {
    margin-top: 21px;
    color: #999999;
    .home {
      color: #282828;
    }
  }
  .orderTip {
    padding: 55px 30px 31px 30px;
    font-size: 32px;
    color: #fff;
    width: 1200px;
    height: 159px;
    background: url("../assets/images/orderBg.png") no-repeat;
    background-size: 100% 100%;
    .times {
      font-size: 14px;
      margin-top: 12px;
    }
  }
  .detail {
    width: 100%;
    height: 182px;
    background-color: #fff;
    padding: 31px 30px;
    .item {
      font-size: 16px;
      .order_price {
        color: #E93323;
      }
      & ~ .item {
        margin-top: 12px;
      }
    }
  }
  .payType {
    width: 100%;
    height: 387px;
    background-color: #fff;
    margin-top: 17px;
    .title {
      height: 57px;
      padding: 0 30px;
      border-bottom: 1px dotted #CECECE;
      line-height: 57px;
      font-size: 18px;
    }
    .type {
      padding: 22px 50px 55px 30px;
      flex-wrap: wrap;
      .item {
        width: 192px;
        height: 86px;
        border: 1px solid #D4D4D4;
        position: relative;
        cursor: pointer;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        & ~ .item {
          margin-left: 20px;
        }
        &.on {
          border-color: #E93323;
        }
        .pay-main {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          text-align: center;
        }
        .pay-image {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
        .iconfont {
          color: #09BB07;
          font-size: 40px;
          &.icon-yue {
            color: #FE9C01;
          }
        }
        .icon-xuanzhong4 {
          position: absolute;
          right: -4px;
          bottom: -6px;
          margin: 0 !important;
        }
        .name {
          font-size: 16px;
          color: #4E4E4E;
          margin-top: 8px;
          line-height: 1;
        }
        .custom-pay-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          line-height: 36px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          &.union {
            background-color: #d94242;
          }
          &.poli {
            background-color: #236fe9;
          }
        }
      }
    }
    .goPay {
      margin: 80px 50px 0 0;
      .bnt,.button {
        width: 180px;
        height: 46px;
        font-size: 16px;
        color: #fff;
        border-radius: 4px;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
      }
      .button{
        outline: none;
        border: none;
        background-color: #E93323 ;
        &:disabled {
          border-color: #fab6b6;
          background-color: #fab6b6;
        }
      }
    }
  }
}
::v-deep .el-dialog {
  width: 1000px;
}
.wrapper {
  background-color: #fff;
  .title {
    margin-bottom: 51px;
    font-size: 20px;
    .amount {
      font-size: 14px;
      color: #969696;
      .num {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
  .wx {
    width: 310px;
    .pictrue {
      width: 100%;
      height: 310px;
      border: 1px solid #ccc;
      position: relative;
      &>img {
        width: 100%;
        height: 100%;
      }
      .fail-code{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0,0 ,0,0.9);
        display: flex;
        align-items: center;
        cursor: pointer;
        .fail-code-info{
          text-align: center;
          width: 100%;
          color: #fff;
          &>img{
            display: inline-block;
            width: 50px;
            height: 50px;
          }
          &>div{
            margin-top: 10px;
          }
        }
      }
    }
    .text {
      width: 100%;
      height: 72px;
      background-color: #EB5E4A;
      color: #fff;
      font-size: 14px;
      margin-top: 16px;
      .iconfont {
        font-size: 50px;
        margin-right: 30px;
      }
      .tip {
        margin-top: 4px;
      }
    }
  }
  .phone {
    margin-left: 144px;
    width: 262px;
    height: 399px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .selectPay {
    font-size: 16px;
    color: #236FE9;
    margin-top: 68px;
    cursor: pointer;
    .iconfont {
      margin-right: 16px;
      font-size: 15px;
    }
  }
}
</style>
